export const API_BASE_URL = "https://mindbridge-gu12.onrender.com";
